<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div v-if="exportLoading">
              Loading. . .
            </div>
            <div v-else>
              <b-button size="sm" variant="primary" @click="exportUser">Export</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="accountData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'btn'">
                      <div class="p-1">
                        <b-button v-if="!props.row.certificate" pill size="sm" v-b-modal.modal-certificate @click="setModalCertificateData(props.row)">Create Certificate</b-button>
                        <b-button v-else pill size="sm" v-b-modal.modal-certificate @click="setModalCertificateData(props.row, 'edit')">Edit Certificate</b-button>
                      </div>
                    </div>
                    <div v-else-if="props.column.field === 'additional_data.classroom_topic'">
                      <span> {{props.row.additional_data.classroom_topic ? props.row.additional_data.classroom_topic.replaceAll('-', ' ').replace(/\b(\w)/g, s => s.toUpperCase()) : ''}}</span>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>


            <b-modal id="modal-certificate" size="lg" title="Certificate" button-size="sm">
              <label>Certificate Code:</label>
              <b-form-input type="text" v-model="certificate.certificate_code" placeholder="Input Certificate Code"></b-form-input>
              <label>Completed Date:</label>
              <b-form-datepicker v-model="certificate.completed_date" class="mb-2" placeholder="Input Completed Date" locale="id"></b-form-datepicker>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button v-if="mode === 'create'" variant="primary" :disabled="loadingUpdate" size="sm" @click="createCertificate">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Submit
                  </div>
                </b-button>
                <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updateCertificate">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Submit
                  </div>
                </b-button>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
export default {
  name: "ping-guru",
  page: {
    title: "Ping Guru",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchAccountData()
  },
  data() {
    return {
      title: "Ping Guru",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      accountData: [],
      columns: [
        { field: "name", label: "Nama Depan" },
        { field: "additional_data.last_name", label: "Nama Belakang" },
        { field: "birth_date", label: "Tanggal Lahir" },
        { field: "hp", label: "Nomor Handphone" },
        { field: "additional_data.ping_guru_email", label: "Email" },
        { field: "additional_data.classroom_topic", label: "Topik" },
        { field: "transaction.payment_methode_name", label: "Metode Pembayaran" },
        { field: "transaction.transaction_status", label: "Status Pembayaran" },
        { field: "btn", label: "#" },
      ],
      exportLoading: false,
      certificate: {
        certificate_code: '',
        completed_date: '',
        event_name: 'ping_guru'
      },
      loadingUpdate: false,
      mode: 'create',
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchAccountData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallAccountData(params)
    },
    httpCallAccountData(params) {
      axios.get("/api/account/ping-guru?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.accountData = data
            this.isFetched = true
          });
    },
    exportUser() {
      this.exportLoading = true
      axios.get("/api/account/ping-guru/export")
          .then(resp => {
            const { data } = resp.data
            var temp = 'data:application/vnd.ms-excel;base64,'
                +encodeURIComponent(data);
            var download = document.createElement('a');
            download.href = temp;
            download.download = 'ping-guru-export.xlsx';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            this.exportLoading = false
          });
    },
    setModalCertificateData(rowData, mode = 'create') {
      this.activeAccount = rowData
      if (mode !== 'create') {
        this.certificate = rowData.certificate
      } else {
        this.certificate = {
          certificate_code: '',
          completed_date: '',
          event_name: 'ping_guru'
        }
      }
      this.mode = mode
    },
    createCertificate() {
      const validate = this.validateCertificate()
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      this.certificate.account_id = this.activeAccount.id
      axios.post("/api/certificate", this.certificate)
          .then(resp => {
            this.loadingUpdate = false
            Swal.fire('Success')
            this.$bvModal.hide('modal-certificate')
            this.fetchAccountData()
          }).catch(() => {
        this.loadingUpdate = false
        Swal.fire("Failed to process", "", "error")
      })
    },
    updateCertificate() {
      const validate = this.validateCertificate()
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      this.certificate.account_id = this.activeAccount.id
      axios.put("/api/certificate/"+this.certificate.id, this.certificate)
          .then(resp => {
            this.loadingUpdate = false
            Swal.fire('Success')
            this.$bvModal.hide('modal-certificate')
            this.fetchAccountData()
          }).catch(() => {
        this.loadingUpdate = false
        Swal.fire("Failed to process", "", "error")
      })
    },
    validateCertificate() {
      const payload = this.certificate
      let result = []
      if (payload.certificate_code === '') {
        result.push('code')
      }
      if (payload.completed_date === '') {
        result.push('completed_date')
      }

      return result
    },
    raiseValidationError(field) {
      const tagLi = field.map(x => '<li>Field '+ x.toUpperCase() +' belum diisi</li>').join('')
      Swal.fire({
        title: '',
        icon: 'error',
        html:
            `
            <b>Mohon isi data</b>
            <ul style="list-style-type:disc; text-align:left">
                ${tagLi}
            </ul>`,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText:
            'OK',
      })
    },
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        name: value,
        sort: '-id',
      })
      this.httpCallAccountData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>